import classnames from 'classnames'
import ProjectProgress from 'components/Project/Progress/ProjectProgress'
import PropTypes from 'prop-types'
import { Link } from 'raspberry-pi-bits'

import './ProgressCard.scss'

const ProgressCard = ({
  children,
  horizontal,
  progress,
  showProgress = true,
  to,
  ...props
}) => {
  const classNames = classnames({
    'c-progress-card': true,
    'c-progress-card--horizontal': horizontal,
  })

  return (
    <Link {...props} className={classNames} excludeClassname={true} to={to}>
      <div className="c-progress-card__children">
        <img
          alt=""
          className="c-progress-card__image"
          src={progress.heroImage}
        />

        <div className="c-progress-card__wrapper">
          <div className="c-progress-card__content">
            <span className="c-progress-card__title">{progress.title}</span>
            {children}
          </div>

          <div className="c-progress-card__progress">
            {showProgress && !progress.completedInternal && (
              <ProjectProgress
                id={progress.repositoryName}
                stepCount={progress.stepCount}
                step={progress.step}
                theme={progress.theme}
              />
            )}

            {showProgress && progress.completedInternal && (
              <div className="c-progress-card__completed">
                <div className="c-progress-card__completed-wrapper">
                  <div className="c-progress-card__badge">
                    <div className="c-progress-card__check" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Link>
  )
}

ProgressCard.propTypes = {
  children: PropTypes.node,
  horizontal: PropTypes.bool,
  progress: PropTypes.object,
  showProgress: PropTypes.bool,
  to: PropTypes.string,
}

export default ProgressCard
